export enum WorkerStatus {
  ForApprovalByOwner = 'FOR_APPROVAL_BY_OWNER',
  NotTrained = 'NOT_TRAINED',
  Trained = 'TRAINED',
  NoWorkers = 'NO_WORKERS',
}
